<template>
  <v-container v-if="loading" fill-height :pa-0="$vuetify.breakpoint.smAndDown">
    <v-layout align-center justify-center>
      <v-flex xs12>
        <loading/>
      </v-flex>
    </v-layout>
  </v-container>
  <v-container fluid :pa-0="$vuetify.breakpoint.smAndDown" v-else>
    <v-card>
      <v-card-title>
        <document-toolbar
          :id="id"
          :name="name"
          :title="title"
          :created_on="document.created_on"
          :addItems="true"
          @openDocument="openDocument"
          @closeDocument="closeDocument"
        />
      </v-card-title>
      <v-card-text>
        <form>
          <v-textarea
            v-model="document.comment"
            auto-grow
            name="comment"
            id="comment"
            label="Комментарий"
            rows="1"
          ></v-textarea>
        </form>
      </v-card-text>
      <component
        :is="schetComponent"
        :records="document.records"
        @openOptionsDialog="openOptionsDialog"
        :summa="document.summa"
        @deleteRow="deleteRow"
      />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="openEntitiesModal" :icon="$vuetify.breakpoint.xsOnly">
          <v-icon v-if="$vuetify.breakpoint.xsOnly">
            mdi-file-excel
          </v-icon>
          <template v-else>
            Excel
          </template>
        </v-btn>
        <v-btn
          color="red"
          :dark="!saving"
          @click="deleteDocument"
          :icon="$vuetify.breakpoint.xsOnly"
          :disabled="saving"
        >
          <v-icon v-if="$vuetify.breakpoint.xsOnly">
            mdi-delete
          </v-icon>
          <template v-else>
            Удалить
          </template>
        </v-btn>
        <v-btn
          color="green"
          :dark="document.records.length > 0 && commonQty > 0"
          @click="saveDocument"
          :icon="$vuetify.breakpoint.xsOnly"
          :disabled="document.records.length === 0 || commonQty <= 0"
          :loading="saving"
        >
          <v-icon v-if="$vuetify.breakpoint.xsOnly">
            mdi-content-save
          </v-icon>
          <template v-else>
            Сохранить
          </template>
        </v-btn>
        <v-btn color="secondary" @click="closeDocument" :icon="$vuetify.breakpoint.xsOnly">
          <v-icon v-if="$vuetify.breakpoint.xsOnly">
            mdi-close
          </v-icon>
          <template v-else>
            Закрыть
          </template>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar
      :color="messageType"
      :timeout="5000"
      :bottom="true"
      v-model="messageDisplay"
    >
      {{ messageText }}
      <v-btn flat icon @click.native="messageDisplay = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <schet-entities-modal
      ref="schetEntitiesModal"
      @excel="excel"
    />
    <product-options
      ref="productOptions"
      @updateDocumentRecord="updateDocumentRecord"
    />
  </v-container>
</template>

<script>
import DocumentsApi from '../api'
import schetTable from './SchetTable'
import schetList from './SchetList'
import ProductOptions from '@/components/common/ProductOptions'
import schetEntitiesModal from './SchetEntitiesModal'
import documentTweaks from '../mixins/documentTweaks'
import editableDocumentTweaks from '../mixins/editableDocumentTweaks'
import { map } from 'lodash'

export default {
  name: 'schet',
  mixins: [
    documentTweaks,
    editableDocumentTweaks
  ],
  components: {
    schetTable,
    schetList,
    schetEntitiesModal,
    ProductOptions
  },
  data () {
    return {
      name: 'schet',
      title: 'Счет'
    }
  },
  computed: {
    schetComponent () {
      return this.$vuetify.breakpoint.smAndDown ? 'schet-list' : 'schet-table'
    }
  },
  methods: {
    getRecordsForSave () {
      return map(this.document.records, (record) => {
        return {
          nomenklatura_id: record.nomenklatura_id,
          kolichestvo: record.wanted,
          attributes: record.attributes,
          toppings: record.toppings
        }
      })
    },
    deleteRow (item) {
      const index = this.document.records.indexOf(item)
      this.document.records.splice(index, 1)
    },
    openOptionsDialog (item) {
      this.$refs.productOptions.open(item, false, this.id, 1)
    },
    updateDocumentRecord (item) {
      let record = this.document.records.find((record) => record.nomenklatura_id === item.nomenklatura_id)
      Object.assign(record, item)
    },
    openEntitiesModal () {
      this.$refs.schetEntitiesModal.open()
    },
    async excel (payload) {
      await DocumentsApi.excel(Object.assign({ id: this.id, name: this.name }, payload))
    }
  }
}
</script>

<style lang="stylus">
  .table-qty {
    border: 1px solid rgba(0, 0, 0, 0.12);
    width: 50px;
    margin: 0;
    text-align: right;
    padding: 5px;
    outline: none;
  }
</style>
